import { Link } from "react-router";

import { PatternChips } from "@/shared/components/PatternChips";
import { Callout } from "@/shared/foundation/primitives";
import { Goto } from "@/shared/navigation";

import styles from "./IngestionRuleNudge.module.css";

/**
 * On a rule converted from a trigger whose `!` patterns became excludes. A
 * trigger matches each of its patterns on its own, so those never kept a file
 * out; the rule will. Says so without blocking the save.
 */
export function TriggerExclusionsNote({
  patterns,
}: {
  patterns: readonly string[];
}) {
  return (
    <Callout
      variant="warning"
      className={styles.nudge}
      data-testid="trigger-exclusions-note"
      action={<PatternChips patterns={patterns} variant="exclude" />}
    >
      The trigger listed these as exclusions, but triggers don&rsquo;t apply
      them, so it ingested these files anyway. This rule will skip them.
    </Callout>
  );
}

/** On a rule whose action does not look like it ingests files. */
export function NotAnIngestionActionWarning() {
  return (
    <Callout
      variant="warning"
      className={styles.nudge}
      data-testid="not-an-ingestion-action"
    >
      This action doesn&rsquo;t look like it ingests files. For analysis,
      reports or notifications,{" "}
      <Link to={Goto.route.CreateTrigger}>use a trigger</Link>.
    </Callout>
  );
}
